export const categories = [
  {
    id: '1',
    name: 'Restaurants',
    slug: 'restaurants',
    icon: 'ri-restaurant-line',
    description: 'Cuisine locale et internationale',
  },
  {
    id: '2',
    name: 'Hôtels',
    slug: 'hotels',
    icon: 'ri-hotel-line',
    description: 'Hébergement de qualité',
  },
  {
    id: '3',
    name: 'Cafés',
    slug: 'cafes',
    icon: 'ri-cup-line',
    description: 'Cafés et salons de thé',
  },
  {
    id: '4',
    name: 'Supermarchés',
    slug: 'supermarches',
    icon: 'ri-shopping-cart-line',
    description: 'Grande distribution',
  },
  {
    id: '5',
    name: 'Pharmacies',
    slug: 'pharmacies',
    icon: 'ri-medicine-bottle-line',
    description: 'Santé et médicaments',
  },
  {
    id: '6',
    name: 'Cliniques',
    slug: 'cliniques',
    icon: 'ri-hospital-line',
    description: 'Soins médicaux',
  },
  {
    id: '7',
    name: 'Écoles',
    slug: 'ecoles',
    icon: 'ri-school-line',
    description: 'Éducation et formation',
  },
  {
    id: '8',
    name: 'Banques',
    slug: 'banques',
    icon: 'ri-bank-line',
    description: 'Services financiers',
  },
  {
    id: '9',
    name: 'Salons de beauté',
    slug: 'salons-beaute',
    icon: 'ri-scissors-cut-line',
    description: 'Coiffure et esthétique',
  },
  {
    id: '10',
    name: 'Garages',
    slug: 'garages',
    icon: 'ri-car-line',
    description: 'Mécanique et entretien',
  },
  {
    id: '11',
    name: 'Boutiques',
    slug: 'boutiques',
    icon: 'ri-store-line',
    description: 'Commerce de détail',
  },
  {
    id: '12',
    name: 'Agences immobilières',
    slug: 'agences-immobilieres',
    icon: 'ri-building-line',
    description: 'Location et vente',
  },
  {
    id: '13',
    name: 'Art & Culture',
    slug: 'art-culture',
    icon: 'ri-palette-line',
    description: 'Galeries, création et patrimoine',
  },
  {
    id: '14',
    name: 'Artisanat',
    slug: 'artisanat',
    icon: 'ri-hammer-line',
    description: 'Fait main et tradition',
  },
  {
    id: '15',
    name: 'Mode & Wax',
    slug: 'mode-wax',
    icon: 'ri-t-shirt-line',
    description: 'Vêtements et accessoires',
  },
  {
    id: '16',
    name: 'Musique & Divertissement',
    slug: 'musique-divertissement',
    icon: 'ri-music-2-line',
    description: 'Concerts et événements',
  },
  {
    id: '17',
    name: 'Tourisme & Voyages',
    slug: 'tourisme-voyages',
    icon: 'ri-plane-line',
    description: 'Découverte et patrimoine',
  },
  {
    id: '18',
    name: 'Technologie & Informatique',
    slug: 'technologie-informatique',
    icon: 'ri-computer-line',
    description: 'Services numériques',
  },
  {
    id: '19',
    name: 'Agriculture & Agroalimentaire',
    slug: 'agriculture-agroalimentaire',
    icon: 'ri-plant-line',
    description: 'Production locale',
  },
  {
    id: '20',
    name: 'Événementiel',
    slug: 'evenementiel',
    icon: 'ri-calendar-event-line',
    description: 'Organisation d\'événements',
  },
];